module.exports = __webpack_public_path__ + "static/media/Cultural-differences-to-be-aware.d87e46de.jpg";